import { ChangeDetectorRef, Component, ElementRef, HostBinding, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import icBookmarks from '@iconify/icons-ic/twotone-bookmarks';
import emojioneUS from '@iconify/icons-emojione/flag-for-flag-united-states';
import emojioneDE from '@iconify/icons-emojione/flag-for-flag-germany';
import icMenu from '@iconify/icons-ic/twotone-menu';
import { ConfigService } from '../../services/config.service';
import { map } from 'rxjs/operators';
import icPersonAdd from '@iconify/icons-ic/twotone-person-add';
import icAssignmentTurnedIn from '@iconify/icons-ic/twotone-assignment-turned-in';
import icBallot from '@iconify/icons-ic/twotone-ballot';
import icDescription from '@iconify/icons-ic/twotone-description';
import icAssignment from '@iconify/icons-ic/twotone-assignment';
import icReceipt from '@iconify/icons-ic/twotone-receipt';
import icDoneAll from '@iconify/icons-ic/twotone-done-all';
import { NavigationService } from '../../services/navigation.service';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import icSearch from '@iconify/icons-ic/twotone-search';
import { BroadcastService } from 'src/app/services/broadcast.service';
import { Message } from 'src/app/interfaces/message.model';
import { ToolbarUserDropdownComponent } from './toolbar-user/toolbar-user-dropdown/toolbar-user-dropdown.component';
import { AppComponent } from 'src/app/app.component';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { SwitchToComponent } from 'src/app/components/businessGroupManagement/switch-to/switch-to.component';
import { BusinessGroupManagementService } from 'src/app/services/business-group-management.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {

  @Input() mobileQuery: boolean;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;
  breadcrumbs: any = [];
  currentPage: any;

  navigationItems = this.navigationService.items;

  isHorizontalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$ = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$ = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));

  icSearch = icSearch;
  icBookmarks = icBookmarks;
  emojioneUS = emojioneUS;
  emojioneDE = emojioneDE;
  icMenu = icMenu;
  icPersonAdd = icPersonAdd;
  icAssignmentTurnedIn = icAssignmentTurnedIn;
  icBallot = icBallot;
  icDescription = icDescription;
  icAssignment = icAssignment;
  icReceipt = icReceipt;
  icDoneAll = icDoneAll;
  icArrowDropDown = icArrowDropDown;
  dropdownOpen: boolean;
  switchToitems:any = []
  showSwitchTo:boolean = false;
  bg_user_name:string = ''


  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private navigationService: NavigationService,
              private popoverService: PopoverService,
              private broadcastService:BroadcastService,
              private popover: PopoverService,
              private cd: ChangeDetectorRef,
              private cookieService: CookieService

              ) { 
               
              }

  ngOnInit() {
    let a = window.location.href.split("#")[1];
    var b = a.split("/");
    
  }

  ngAfterViewInit(): void {
    this.broadcastService.on(new Message('BreadCrum', null)).subscribe(event => this.runBreadCrum(event));
    this.broadcastService.on(new Message('switchToData', null)).subscribe(event => this.switchToitems = event.payload);
   
  }

  ngDoCheck(){
    if(this.cookieService.get('user_role') === 'cms_manager' && location.href.split("#")[1] !== '/cms/business-group'){
      this.showSwitchTo = true
    }
    
    if(this.cookieService.get('bg_user_name')){
      this.bg_user_name = this.cookieService.get('bg_user_name')
    }
  }

  setUserName(){
    this.bg_user_name = this.cookieService.get('bg_user_name')
  }

  runBreadCrum(event) {    
    this.breadcrumbs = [];
    this.breadcrumbs = event.payload;
    this.currentPage = this.breadcrumbs[this.breadcrumbs.length-1].title;
  }
  openQuickpanel() {
    this.layoutService.openQuickpanel();
  }

  openSidenav() {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement) {
    this.popoverService.open({
      content: MegaMenuComponent,
      // data: 
      origin,
      position: [
        {
          originX: 'start',
          originY: 'bottom',
          overlayX: 'start',
          overlayY: 'top'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });
  }


  openSearch() {
    this.layoutService.openSearch();
  }

  reload(obj){
    this.breadcrumbs = obj;
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: SwitchToComponent,
      data: this.switchToitems,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top',
        },
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
      if(this.cookieService.get('user_role') === 'cms_manager'){
        this.bg_user_name = this.cookieService.get('bg_user_name')
      }
    });

  }
}
